import { Grid, Typography } from "src/lib/components/basics";
import { StyledHeader } from "./styled";
import { IChatHeaderProps } from "./types";
import { AutoAwesome, Fullscreen, FullscreenExit } from "@mui/icons-material";
import { CloseButton } from "./CloseButton";
import { IconButton } from "@mui/material";

const Header = (props: IChatHeaderProps) => {
    return (
        <StyledHeader>
            <Grid container alignContent="center" gap={2}>
                <AutoAwesome/>
                <Typography>
                    Assistente Virtual
                </Typography>
                <Grid item sx={{marginLeft: "auto"}}>
                    <IconButton
                        onClick={props.onToggleFullscreen}
                        sx={{ color: "neutral.lightest" }}
                    >
                        {props.isFullscreen ? <FullscreenExit/> : <Fullscreen/>}
                    </IconButton>
                    <CloseButton onClick={props.onClose}/>
                </Grid>
            </Grid>
        </StyledHeader>
    )
}

export {Header}